/**
 * Copyright ©2025 Drivepoint
 */

import {Store} from "@bainbridge-growth/node-frontend";
import WebAppServerClient from "../clients/WebAppServerClient";
import State from "../state/State";
import {StateEvent} from "../state/StateEvent";

export default class PermissionGroupsStore extends Store {

  init(): void {
    this.loading = true;
    State.register("user", (event: StateEvent) => {
      this.value = [];
      if (event.value?.excelUser?.role === "superAdmin") { this.refresh(); }
    });
  }

  async refresh(): Promise<void> {
    return this.action(async () => {
      this.value =  await WebAppServerClient.request("/api/permission_groups", "GET");
    });
  }

  async create(group: any): Promise<void> {
    return this.action(async () => {
      await WebAppServerClient.request("/api/permission_groups", "POST", group);
      this.refresh();
    });
  }

  async update(group: any): Promise<void> {
    return this.action(async () => {
      await WebAppServerClient.request(`/api/permission_groups/${group.id}`, "PATCH", group);
      this.refresh();
    });
  }

  async delete(group: any): Promise<void> {
    return this.action(async () => {
      await WebAppServerClient.request(`/api/permission_groups/${group.id}`, "DELETE");
      this.refresh();
    });
  }

}
